import { Component, OnInit } from '@angular/core';
import { ApiSwitcherService, ApiSource } from '../../_services/api-switcher.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-api-switcher',
  templateUrl: './api-switcher.component.html',
  styleUrls: ['./api-switcher.component.scss']
})
export class ApiSwitcherComponent implements OnInit {
  currentSource: ApiSource;
  isExpanded = false;
  showEnabled = !environment.production;

  constructor(private apiSwitcherService: ApiSwitcherService) {}

  ngOnInit(): void {
    this.currentSource = this.apiSwitcherService.currentSource;
    this.apiSwitcherService.apiSourceChanged.subscribe(source => {
      this.currentSource = source;
    });
  }

  toggle(): void {
    this.apiSwitcherService.toggle();
  }

  switchTo(source: ApiSource): void {
    this.apiSwitcherService.switchTo(source);
    // Reload to ensure all services use the new URL
    window.location.reload();
  }

  get activeUrl(): string {
    return this.apiSwitcherService.activeApiUrl;
  }

  get isPhp(): boolean {
    return this.currentSource === 'php';
  }
}
